import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CloseLineIcon from '@icons/CloseLineIcon';
import { pressActionEffect } from '@styles/mixin';
import {
    Dispatch, SetStateAction, useEffect, useRef, useState,
} from 'react';
import { createPortal } from 'react-dom';

import useImageModal from './hooks/useImageModal';

interface Props {
    images: string[];
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

function ImageModal({ images, isOpen, setIsOpen }:Props) {
    const [index, setIndex] = useState<number>(0);
    const { isHide, isNone } = useImageModal(isOpen);
    return (
        <Dim isHide={isHide} isNone={isNone} >
            <Container>
                <ImageRow
                    fullWidth
                    onScroll={(e) => {
                        const { scrollLeft, scrollWidth, offsetWidth } = e.currentTarget;
                        setIndex(Math.round(scrollLeft / (scrollWidth - offsetWidth)));
                    }} >
                    {images.map((image, idx) => (
                        <FullImage src={image}
                            key={`${image} ${idx}`}
                            width={400}
                            height={200}
                            alt='상품 상세 이미지' />
                    ))}
                </ImageRow>
                <Text size='title-lg' color={colors.white} fontWeight='medium'>
                    {index + 1 } /  {images.length}
                </Text>
                <CloseButton size={36}
                    color={colors.white}
                    onClick={() => setIsOpen(false)} />
            </Container>
        </Dim>
    );
}

const Dim = styled.div<{
    isHide?: boolean;
    isNone?: boolean;
}>`
    background-color: rgba(0, 0, 0, 0.5);
    height: 100vh;
    left: 0;
    position: absolute;
    top: 0;
    transition: 300ms ease-in-out;
    width: 100vw;
    z-index: 100;
    display: ${({ isNone }) => (isNone ? 'none' : 'block')};
    opacity: ${({ isHide }) => (isHide ? 0 : 1)};
`;

const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: center;
    position: relative;
    row-gap: 16px;
    width: 100vw;
`;

const ImageRow = styled(Row)`
    max-width: var(--max-view-port-width);
    overflow: scroll;
    scroll-snap-type: x mandatory;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const FullImage = styled(Image)`
    height: auto;
    min-width: 100%;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    width: 100%;
    background-color: white;
`;

const CloseButton = styled(CloseLineIcon)`
    position: absolute;
    right: 16px;
    top: calc(48px + var(--safe-area-top));
    ${pressActionEffect}
`;

const component = (props: Props) => createPortal(<ImageModal {...props}/>, document.body);

export default component;
